import { Month } from  '@/interfaces/LockerManagement'

export function getShortMonthFromEnum(month: Month): string {
    return ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][month]
}


export function timeToDecimal(timeString: string) {
    return timeString.split(':')
          .map((val) =>  parseInt(val, 10))
          .reduce((prev, current, index) => {
              return prev + current / Math.pow(60, index);
          });
}

export function dateStringToHoursAndMinutes(dateString: string) {
    const date = new Date(dateString);
    const options = {hour: "2-digit", minute: "2-digit", hourCycle: 'h23'};
    return new Intl.DateTimeFormat("en-US", options as unknown).format(date);
}

export function hoursAndMinutesBetweenTwoDates(dateString1: string, dateString2: string) {
    const diff = Math.abs(new Date(dateString2).getTime() - new Date(dateString1).getTime());
    const diffInMinutes = Math.floor((diff/1000)/60);

    if(diffInMinutes % 60 === 0) {
        return `${diffInMinutes /60}`
    }
    return `${Math.floor(diffInMinutes  / 60)}:${diffInMinutes % 60 }`
}

export function getTrialDaysLeft(date: string): number {
    if (!date) return 0;

    const [datePart] = date.split(" ");
    const parts = datePart.split("/");

    if (parts.length !== 3) return 0;

    const [day, month, year] = parts.map(Number);

    if (!day || !month || !year) return 0;

    const createdDate = new Date(Date.UTC(year, month - 1, day));

    if (isNaN(createdDate.getTime())) return 0;

    const today = new Date();
    const todayUtc = new Date(Date.UTC(
        today.getUTCFullYear(),
        today.getUTCMonth(),
        today.getUTCDate()
    ));

    const diffMs = todayUtc.getTime() - createdDate.getTime();
    const daysSinceCreated = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    return Math.max(30 - daysSinceCreated, 0);
}

